import React from 'react';
import styles from './index.css';
import { h5PageCount } from '../../../utils';
const { callApp } = require('@ifeng/callapp');
class CallupHead extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isClose: true,
            keyword: '',
        };
        this.handleClick = (url, id, newstype, userId, others, position, downloads) => {
            const { topClickInfo, fixClickInfo, isVideoShare, pageInfo } = this.props.content;
            const doc_type = newstype;
            const aid = id;
            const userIdVal = userId || '';
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            if (!downloads) {
                if (isVideoShare) {
                    downloads = {
                        download: '',
                        downloadAd: ''
                    };
                }
                else {
                    downloads = {
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354726493926',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7639',
                    };
                }
            }
            if (position === 1 && topClickInfo) {
                h5PageCount([
                    {
                        behavior: topClickInfo.behavior || 'action',
                        type: topClickInfo.type || 'upopen',
                        other: {
                            ref: topClickInfo.ref || '',
                            kind: topClickInfo.kind || '',
                        },
                    },
                ]);
                callApp({
                    client,
                    docType: doc_type,
                    pid: aid,
                    kind: topClickInfo.callupKind,
                    download: downloads.download,
                    downloadAd: downloads.downloadAd,
                    userId: userIdVal
                });
            }
            else if (position === 2) {
                h5PageCount([
                    {
                        behavior: (fixClickInfo && fixClickInfo.behavior) || 'action',
                        type: (fixClickInfo && fixClickInfo.type) || 'grgxfc',
                        other: {
                            ref: (fixClickInfo && fixClickInfo.ref) || '',
                            kind: (fixClickInfo && fixClickInfo.kind) || '',
                        },
                    },
                ]);
                callApp({
                    client,
                    docType: doc_type,
                    pid: aid,
                    kind: (fixClickInfo && fixClickInfo.callupKind) || '',
                    download: downloads && downloads.download,
                    downloadAd: downloads && downloads.downloadAd,
                    userId: userIdVal
                });
            }
        };
        this.clickFixedFn = () => {
            this.setState({
                isClose: true,
            });
        };
        this.header = React.createRef();
    }
    componentDidMount() {
        const { pageInfo, hotKeyword } = this.props.content;
        const keywordStr = hotKeyword[Math.floor(Math.random() * hotKeyword.length)];
        this.setState({
            keyword: keywordStr,
        });
        if (pageInfo) {
            this.isHideFn();
        }
    }
    isHideFn() {
        const headerHeight = (this.header.current && this.header.current.offsetHeight) || 0;
        const srcollBox = document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop);
        let beforeScrollTop = srcollBox || 0;
        let stausDown = true;
        let stausUp = true;
        let isScroll = true;
        let isTop = true;
        window.addEventListener('scroll', () => {
            // if (!isScroll) return false;
            const afterScrollTop = document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop) || 0;
            const delta = afterScrollTop && afterScrollTop - beforeScrollTop;
            if (isTop && ((afterScrollTop && afterScrollTop <= headerHeight) || afterScrollTop === 0)) {
                isTop = false;
                setTimeout(() => {
                    isScroll = true;
                }, 300);
                this.setState({
                    isClose: true,
                });
                return false;
            }
            else if (afterScrollTop && afterScrollTop > headerHeight) {
                isTop = true;
            }
            if (delta === 0 || (afterScrollTop && afterScrollTop <= headerHeight)) {
                return false;
            }
            if (delta && delta > 0 && stausUp) {
                stausDown = true;
                stausUp = false;
                isScroll = false;
                setTimeout(() => {
                    isScroll = true;
                }, 300);
                this.setState({
                    isClose: true,
                });
                // console.log('向下');
            }
            else if (delta && delta < 0 && stausDown) {
                stausUp = true;
                stausDown = false;
                isScroll = false;
                setTimeout(() => {
                    isScroll = true;
                }, 300);
                this.setState({
                    isClose: false,
                });
                // console.log('向上');
            }
            beforeScrollTop = afterScrollTop;
            return false;
        }, false);
    }
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { pageInfo, hotKeyword, isVideoShare, maxWidth } = this.props.content;
        const { isClose, keyword } = this.state;
        const maxWidthStyle = maxWidth ? {
            maxWidth: `${maxWidth}`
        } : {};
        return (React.createElement(React.Fragment, null,
            React.createElement("header", { ref: this.header, className: styles.header },
                React.createElement("a", { onClick: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 1, pageInfo.downloads), href: "javascript:;", className: styles.headerBox },
                    React.createElement("span", { className: `${styles.logo} ${isVideoShare && styles.videoLogo}` }),
                    React.createElement("span", { className: styles.botton }, "\u7ACB\u5373\u6253\u5F00"))),
            hotKeyword && (React.createElement("header", { style: maxWidthStyle, className: !isClose ? styles.headerIn : styles.headerOut },
                React.createElement("a", { onClick: this.handleClick.bind(this, pageInfo.url, pageInfo.id, pageInfo.type, pageInfo.userId, pageInfo.others, 2, pageInfo.downloads), href: "javascript:;", className: styles.info },
                    React.createElement("h2", { className: styles.title }, keyword),
                    React.createElement("span", { className: styles.openBtn }, "\u6253\u5F00")),
                React.createElement("a", { href: "javascript:;", onClick: this.clickFixedFn, className: styles.close })))));
    }
}
export default CallupHead;
